import { TOOLTIP_STORAGE_KEY } from "@config/beyondWords";
import { useEffect, useRef, useState } from "react";

export function useTooltipOnPlayerReady(
  playerRef: React.RefObject<HTMLElement | null>,
) {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipShownRef = useRef(false);

  useEffect(() => {
    const hasSeen = localStorage.getItem(TOOLTIP_STORAGE_KEY);

    if (hasSeen) return;

    const checkTooltipCondition = () => {
      const player = playerRef.current;

      if (!player) return false;

      if (
        !tooltipShownRef.current &&
        player.classList.contains("bwp") &&
        getComputedStyle(player).display !== "none"
      ) {
        tooltipShownRef.current = true;
        setShowTooltip(true);

        setTimeout(() => {
          localStorage.setItem(TOOLTIP_STORAGE_KEY, "true");
        }, 500);
        return true;
      }

      return false;
    };

    const isOverlayHidden = () => {
      const overlay = document.getElementById("MyPageOverlay");
      const hidden = overlay && getComputedStyle(overlay).display === "none";
      return hidden;
    };

    const pollUntilPlayerAndOverlayReady = () => {
      const intervalId = setInterval(() => {
        if (isOverlayHidden()) {
          const shown = checkTooltipCondition();
          if (shown) {
            clearInterval(intervalId);
          }
        }
      }, 500);
      return () => {
        clearInterval(intervalId);
      };
    };

    const stopPolling = pollUntilPlayerAndOverlayReady();

    return () => {
      stopPolling();
    };
  }, [playerRef]);

  return { showTooltip };
}
